import React, { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import { Calendar } from 'primereact/calendar';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import userImage from '../../assets/images/user.jpeg';
import calendarIcon from '../../assets/icons/calendar.svg';
import useWindowSize from '../../hooks/useWindowSize';
import closeIcon from '../../assets/icons/closeIcon.svg';
import { changeProfile } from '../../store/actions/userAccount';
import Spinner from '../../components/Spinner';

function AccountProfile({ handleCloseMenu }) {
  const { user } = useSelector((state) => state.users);
  const [phoneNumberLength, setPhoneNumberLength] = useState(11);
  const [invalidPhoneNumber, setInvalidPhoneNumber] = useState(false);
  const [preview, setPreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const lang = Cookies.get('i18next') || 'en';
  const { translations } = useSelector((state) => state.translation);
  const dispatch = useDispatch();
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const [name, setName] = useState(user.first_name || '');
  const [lastName, setLastName] = useState(user.last_name || '');
  const [email, setEmail] = useState(user.email);
  const [date, setDate] = useState(new Date(user.dateOfBirth) || null);
  const [phone, setPhone] = useState(user.phone || '');
  const [phoneError, setPhoneError] = useState('');
  const [nameError, setNameError] = useState('');
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [country, setCountry] = useState(user.country || '');
  const [city, setCity] = useState(user.city || '');
  useEffect(() => {
    setPhoneError('');
  }, [phone]);
  const { width } = useWindowSize();
  const handleChangeProfile = async (event) => {
    event.preventDefault();
    setLoadingBtn(true);
    if (phone?.length !== phoneNumberLength) {
      setInvalidPhoneNumber(true);
      setLoadingBtn(false);
      return;
    }
    const { payload } = await dispatch(changeProfile({
      first_name: name,
      last_name: lastName,
      phone,
      email,
      dateOfBirth: date
        ? `${new Date(date).getFullYear()}-${String(new Date(date).getMonth() + 1).padStart(2, '0')}-${String(new Date(date).getDate()).padStart(2, '0')}`
        : '',
      country,
      city,
      image: selectedFile,
      lang,
    }));
    if (payload.status !== 'error') {
      toast(payload.message);
    }
    setLoadingBtn(false);
  };
  return (
    <div className="account__profile">
      <div className="account__profile-top">
        <div className="account__profile-top-mobile">
          <h2 className="account__profile-top-title">{translations.personal_information[lang]}</h2>
          {width < 768
                        && (
                        <button onClick={handleCloseMenu} type="button">
                          <img
                            className="account-close-icon"
                            src={closeIcon}
                            alt=""
                          />
                        </button>
                        )}
        </div>
        <div className="account__profile-top-image-box">
          <img
            src={preview || (user.image_path ? user.image_path : userImage)}
            alt="user"
          />
          <input onChange={handleFileChange} type="file" id="photoInput" accept="image/*" />
          <label htmlFor="photoInput" className="account__profile-top-image-btn">{translations.change_photo[lang]}</label>
        </div>
      </div>
      <form action="#" onSubmit={handleChangeProfile} className="modal-form">
        <div className="middle-block">
          <div className="modal-input-container">
            <div className="modal-input-block">
              <label htmlFor="firstName" className="modal-input-block-label">
                {translations.first_name_label[lang]}
                *
              </label>
              <input
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  setNameError('');
                }}
                placeholder={translations.first_name_placeholder[lang]}
                type="text"
                id="firstName"
                className="modal-input-block-input checkout"
              />
              {nameError && <p className="authError">{nameError}</p>}
            </div>
          </div>
          <div className="modal-input-container">
            <div className="modal-input-block">
              <label htmlFor="lastName" className="modal-input-block-label">
                {translations.last_name_label[lang]}
                *
              </label>
              <input
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder={translations.last_name_placeholder[lang]}
                type="text"
                id="lastName"
                className="modal-input-block-input checkout"
              />
            </div>
          </div>
        </div>
        <div className="middle-block">
          <div className="modal-input-container">
            <div className="modal-input-block">
              <label htmlFor="email" className="modal-input-block-label">
                {translations.email_label[lang]}
                *
              </label>
              <input
                disabled
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={translations.email_placeholder[lang]}
                type="text"
                id="email"
                className="modal-input-block-input checkout"
              />
            </div>
          </div>
          <div className="modal-input-container">
            <div className="modal-input-block">
              <label htmlFor="phone" className="modal-input-block-label">
                {translations.phone[lang]}
                *
              </label>
              <PhoneInput
                id="phone"
                country="am"
                value={phone}
                onChange={(e, info) => {
                  setInvalidPhoneNumber(false);
                  const expectedLength = (info?.format.match(/\./g) || [])
                    .length;
                  setPhoneNumberLength(expectedLength);
                  setPhone(e);
                }}
                containerClass="phone-input-container"
                inputClass="phone-input"
                buttonClass="phone-input-button"
                dropdownClass="phone-input-dropdown"
              />
              {invalidPhoneNumber && (
                <p className="authError">{translations.phone_error[lang]}</p>
              )}
              {phoneError && <p className="authError">{phoneError}</p>}
            </div>
          </div>
        </div>
        <div className="middle-block">
          <div className="modal-input-container">
            <div className="modal-input-block">
              <label htmlFor="date" className="modal-input-block-label">
                {translations['date-birth'][lang]}
                *
              </label>
              <Calendar
                showIcon
                icon={() => (
                  <img
                    src={calendarIcon}
                    alt="calendar"
                    className="calendar-icon"
                  />
                )}
                placeholder={translations.coose_placeholder[lang]}
                value={date}
                onChange={(e) => setDate(e.value)}
                className="calendar"
                inputClassName="calendar-input"
                panelClassName="calendar-panel"
                todayButtonClassName="calendar-today-button"
                clearButtonClassName="calendar-clear-button"
                id="date"
                selectionMode="single"
              />
            </div>
          </div>
          <div className="modal-input-container">
            <div className="modal-input-block">
              <label htmlFor="country" className="modal-input-block-label">
                {translations.country[lang]}
                *
              </label>
              <input
                placeholder={translations.country_placeholder[lang]}
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                type="text"
                id="country"
                className="modal-input-block-input checkout"
              />
            </div>
          </div>
        </div>
        <div className="modal-input-container user">
          <div className="modal-input-block">
            <label htmlFor="city" className="modal-input-block-label">
              {translations.city[lang]}
              *
            </label>
            <input
              placeholder={translations.city_placeholder[lang]}
              value={city}
              onChange={(e) => setCity(e.target.value)}
              type="text"
              id="city"
              className="modal-input-block-input checkout"
            />
          </div>
        </div>
        <button type="submit" className="change-profile-btn">
          {loadingBtn ? <Spinner isBtn size={30} /> : (
            <>
              <div className="change-profile-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <g clipPath="url(#clip0_127_701)">
                    <path
                      d="M9.57598 2.71927L10.1939 2.10135C11.2177 1.07755 12.8776 1.07755 13.9014 2.10135C14.9252 3.12515 14.9252 4.78506 13.9014 5.80887L13.2835 6.42679M9.57598 2.71927C9.57598 2.71927 9.65322 4.03235 10.8118 5.19095C11.9704 6.34955 13.2835 6.42679 13.2835 6.42679M9.57598 2.71927L3.89515 8.40009C3.51038 8.78487 3.31799 8.97726 3.15254 9.18939C2.95736 9.43962 2.79003 9.71037 2.6535 9.99684C2.53776 10.2397 2.45172 10.4978 2.27964 11.014L1.55048 13.2015M13.2835 6.42679L7.60267 12.1076C7.2179 12.4924 7.02551 12.6848 6.81338 12.8502C6.56315 13.0454 6.2924 13.2127 6.00592 13.3493C5.76307 13.465 5.50495 13.551 4.98872 13.7231L2.80122 14.4523M2.80122 14.4523L2.2665 14.6305C2.01246 14.7152 1.73238 14.6491 1.54302 14.4597C1.35367 14.2704 1.28756 13.9903 1.37224 13.7363L1.55048 13.2015M2.80122 14.4523L1.55048 13.2015"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_127_701">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <p>{translations.edit[lang]}</p>
            </>
          )}
        </button>
      </form>

    </div>
  );
}

export default AccountProfile;
